module.exports = __webpack_public_path__ + "media/yorkshireterrier_m.9f6b0a64.mp3";